import { configureStore } from "@reduxjs/toolkit";
import signUpReducer from "./slices/signup";
import loginReducer from "./slices/login";
import walletPulsarReducer from "./slices/wallet-pulsar";
import confirmMail from "./slices/confirmMail";
import stakingReducer from "./slices/stake";
import logoutReducer from "./slices/logout";
import googleReducer from "./slices/google";
import settingsReducer from "./slices/settings";
import adminReducer from "./slices/admin";
const store = configureStore({
  reducer: {
    signup: signUpReducer,
    login: loginReducer,
    pulsar_wallet: walletPulsarReducer,
    confirm_mail: confirmMail,
    staking: stakingReducer,
    logout: logoutReducer,
    google: googleReducer,
    settings: settingsReducer,
    admin: adminReducer,
  },
});

export default store;
